import { AxiosResponse } from 'axios'
import apiClient from 'api/common/common'
import { Status } from 'api/common/statuses'
import { SettlementResponse } from 'api/common/responses'

/**
 * 個人契約の証明書登録API
 * @param request
 * @param callback
 */
export const settlementListAPI = async (callback: (result: SettlementResponse) => void) => {
  await apiClient
    .get('/settlement')
    .then((response: AxiosResponse<SettlementResponse>) => {
      const status = response?.headers['x-aqc-status'] ?? 'failed'
      if (status === Status.Success) {
        callback(response?.data)
      }
    })
    .catch((error) => {
      console.error(error)
    })
}
